/**
 * 时间格式化函数
 * @param fmt
 * @param date
 * @returns {*}
 */
export function dateFtt(fmt, date) {
  //author: meizz
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

/**
 * 环图总计数字
 */
export function amountFun(arr) {
  let tol = 0;
  arr.map((v) => {
    tol += Number(v.value);
  });
  if (tol > 10000) {
    tol = (tol / 10000).toFixed(2) + "万";
  } else if (!Number.isInteger(tol)) {
    tol = tol.toFixed(2);
  }
  return tol;
}

/**
 * flexWidth
 * @param prop 每列的prop 可传''
 * @param tableData 表格数据
 * @param title 标题长内容短的，传标题  可不传
 * @param num 列中有标签等加的富余量
 * @returns 列的宽度
 * 注：prop,title有一个必传
 */
export function flexWidth(prop, tableData, title, num = 0) {
  if (tableData.length === 0) {
    //表格没数据不做处理
    return;
  }
  let flexWidth = 0; //初始化表格列宽
  let columnContent = ""; //占位最宽的内容
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  context.font = "14px Microsoft YaHei";
  if (prop === "" && title) {
    //标题长内容少的，取标题的值,
    columnContent = title;
  } else {
    // 获取该列中占位最宽的内容
    let index = 0;
    for (let i = 0; i < tableData.length; i++) {
      const now_temp = tableData[i][prop] + "";
      const max_temp = tableData[index][prop] + "";
      const now_temp_w = context.measureText(now_temp).width;
      const max_temp_w = context.measureText(max_temp).width;
      if (now_temp_w > max_temp_w) {
        index = i;
      }
    }
    columnContent = tableData[index][prop];
    //比较占位最宽的值跟标题、标题为空的留出四个位置
    const column_w = context.measureText(columnContent).width;
    const title_w = context.measureText(title).width;
    if (column_w < title_w) {
      columnContent = title || "留四个字";
    }
  }
  // 计算最宽内容的列宽
  let width = context.measureText(columnContent);
  flexWidth = width.width + 40 + num;
  return flexWidth + "px";
}

/**  查找匹配tree字段的路径* */
export function getFathersById(id, data, prop) {
  let arrRes = [];
  let rev = (data, nodeId) => {
    for (let i = 0, length = data.length; i < length; i++) {
      let node = data[i];
      if (node[prop] === nodeId) {
        // arrRes.unshift(node)
        return true;
      } else {
        if (node.children && node.children.length) {
          if (rev(node.children, nodeId)) {
            arrRes.unshift(node);
            return false;
          }
        }
      }
    }
    return false;
  };
  rev(data, id);
  return arrRes;
}

/**  去重 **/
export function arrayUnique(arr, attrName) {
  let map = new Map();
  for (let item of arr) {
    if (!map.has(item[attrName])) {
      map.set(item[attrName], item);
    }
  }
  return [...map.values()];
}

export function formatNumber(num) {
  let reg = /(?=(\B)(\d{3})+$)/g;
  return num.toString().replace(reg, ",");
}

/****   千分位处理  ****/
export function numberToCurrencyNo(value) {
  if (!value) return 0;
  // 获取整数部分
  const intPart = Math.trunc(value);
  // 整数部分处理，增加,
  const intPartFormat = intPart
    .toString()
    .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  // 预定义小数部分
  let floatPart = "";
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split(".");
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString(); // 取得小数部分
    return intPartFormat + "." + floatPart;
  }
  return intPartFormat + floatPart;
}

/****   表格用千分位方法 ****/
export function setTabNumber(row, column, cellValue) {
  if (cellValue || cellValue === 0) {
    cellValue += "";
    if (!cellValue.includes(".")) cellValue += ".";
    return cellValue
      .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  }
}

/****   分钟转换  ****/
export function formatMinutes(minutes) {
  let day = parseInt(Math.floor(minutes / 1440));
  let hour =
    day > 0
      ? Math.floor((minutes - day * 1440) / 60)
      : Math.floor(minutes / 60);
  let minute =
    hour > 0 ? Math.floor(minutes - day * 1440 - hour * 60) : minutes;
  let time = "";
  if (day > 0) time += day + "天";
  if (hour > 0) time += hour + "小时";
  if (minute > 0) time += minute + "分钟";
  return time;
}

/**
 * 毫秒转化为天小时分钟秒
 * @param ms 毫秒值
 * @return
 */
export function formatTime(ms) {
  let days = parseInt(ms / (1000 * 60 * 60 * 24));
  let hours = parseInt((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = parseInt((ms % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((ms % (1000 * 60)) / 1000);
  return (
    days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 "
  );
}

// 报警管理报警描述匹配
export function matchingAlarm(str) {
  let obj = {
    CO2Exceeded: "二氧化碳浓度超标",
    COExceeded: "一氧化碳浓度超标",
    HaveflagExceeded: "该区域位置有人",
    LevelExceeded: "压力超出范围",
    "PM2.5Exceeded": "PM2.5超标",
    PowerExceeded: "超出额定功率",
    PressExceeded: "压力超标",
    RSInTempExceeded: "进水温度超标",
    RSOutTempExceeded: "出水温度超标",
    PPMExceeded: "烟雾浓度超标",
    SO2Exceeded: "二氧化硫超标",
    TemperatureExceeded: "温度超标",
    ZaoyinExceeded: "噪音超标",
    abnormalOperation: "异常运行时间",
  };
  if (obj.hasOwnProperty(str)) {
    return obj[str];
  }
}

export function matchingWeek(week) {
  let obj = {
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
  };
  if (obj.hasOwnProperty(week)) {
    return obj[week];
  }
}

export function judgmentUnit(arr, inx, val) {
  return arr.some((item) => item[inx] >= val);
}
export function handleDataUnit(arr, num) {
  let newArr = Array.from(arr).map((item) => ({
    name: item.name,
    value: item.value ? (item.value / num).toFixed(2) : 0,
  }));
  return newArr;
}

export function matchingAlarmLevel(level) {
  let obj = {
    CRITICAL: "高危",
    MAJOR: "危险",
    MINOR: "警告",
  };
  if (obj.hasOwnProperty(level)) {
    return obj[level];
  }
}
export function matchingAlarmColor(val) {
  let obj = {
    高危: "color:#EC5453",
    危险: "color:#FF9400",
    警告: "color:#777777",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

export function matchingOrderLevel(level) {
  let obj = {
    HIGH: "紧急",
    MEDIUM: "重要",
    LOW: "一般",
  };
  if (obj.hasOwnProperty(level)) {
    return obj[level];
  }
}

export function matchingOrderStatus(status) {
  let obj = {
    TOBE_ASSIGNED: "待派单",
    TOBE_RE_ASSIGNED: "待重新派单",
    TOBE_REPAIR: "待处理",
    TOBE_CONFIRMED: "待确认",
    COMPLETED: "已完成",
    INVALID: "已关闭",
  };
  if (obj.hasOwnProperty(status)) {
    return obj[status];
  }
}

export function matchingOrderSource(val) {
  let obj = {
    createOrder: "创建工单",
    H5Reporting: "H5上报",
    EquipmentAlarm: "设备告警",
    PatrolReport: "巡更上报",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

export function matchingOrderColor(val) {
  let obj = {
    紧急: "color:#E31313",
    重要: "color:#FF6600",
    一般: "color:#FFCC00",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

export function matchingAirAction(val) {
  let obj = {
    REFRIGERATION: "制冷",
    HEATING: "制热",
    AREFACTION: "除湿",
    VENTILATE: "送风",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

/**** 巡检计划匹配** */
export function matchingInspectionCycle(val) {
  let obj = {
    DAY: "日计划",
    WEEK: "周计划",
    MONTH: "月度计划",
    UNLIMITED: "临时计划",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

export function dealBigNum(val) {
  if (val === undefined || val === null) {
    return "";
  }
  return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
}

export function matchingStatus(val) {
  if (val == 1) {
    return "运行中";
  }
  if (val == 0) {
    return "已关闭";
  }
  return val;
}

export function matchingFireStatus(val) {
  if (val == 1) {
    return "小火";
  }
  if (val == 2) {
    return "中火";
  }
  if (val == 3) {
    return "大火";
  }
  return val;
}

export function matchingAirEchartsParams(type, subType) {
  const matchingParams = {
    中央空调主机: {
      total: [
        { left: ["制冷量"] },
        { left: ["机房COP"] },
        { left: ["负荷率"] },
        { left: ["用电量"] },
      ],
      single: [
        {
          left: ["冷冻水", "冷却水"],
          right: ["温度", "压力", "流量"],
        },
        {
          left: ["冷负荷", "主机COP", "制冷量"],
        },
        {
          left: ["电流", "电压", "有功功率", "负荷率"],
        },
        {
          left: ["用电量"],
        },
      ],
    },
    冷冻水泵: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }, { left: ["WTFchw"] }],
      single: [
        {
          left: ["压力"],
        },
        {
          left: ["流量", "温度"],
        },
        {
          left: ["电流", "电压", "有功功率", "负荷", "频率"],
        },
        {
          left: ["用电量"],
        },
      ],
    },
    冷却水泵: {
      total: [
        { left: ["功率"] },
        { left: ["用电量"] },
        { left: ["WTFcw"] },
        { left: ["WTFcwp"] },
      ],
      single: [
        {
          left: ["压力"],
        },
        {
          left: ["流量", "温度"],
        },
        {
          left: ["电流", "电压", "有功功率", "负荷", "频率"],
        },
        {
          left: ["用电量"],
        },
      ],
    },
    冷却塔: {
      total: [
        { left: ["温度", "流量", "冷幅"] },
        { left: ["电流", "电压", "有功功率", "负荷", "频率"] },
        { left: ["用电量"] },
        { left: ["WTFcw", "WTFct"] },
      ],
      single: [
        {
          left: ["压力"],
        },
        {
          left: ["流量", "温度"],
        },
        {
          left: ["电流", "电压", "有功功率", "负荷", "频率"],
        },
        {
          left: ["用电量"],
        },
      ],
    },
    分集水管: {
      total: [{ left: ["温度", "流量", "压力"] }],
      single: [{ left: ["温度", "流量", "压力"] }],
    },
    风机盘管: {
      total: [{ left: ["开启数量", "ATF"] }],
      single: [{ left: ["开启数量", "ATF"] }],
    },
    主机能效: {
      total: [{ left: ["SCOP"] }, { left: ["SEER"] }],
      single: [{ left: ["SCOP"] }, { left: ["SCOP"] }],
    },
    锅炉: {
      total: [
        { left: ["供热量"] },
        { left: ["用气量"] },
        { left: ["锅炉效率"] },
      ],
      single: [
        { left: ["温度", "压力", "流量"] },
        { left: ["供热量"] },
        { left: ["用气量"] },
        { left: ["锅炉效率"] },
      ],
    },
    燃烧风机: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }],
      single: [
        { left: ["电流", "电压", "有功功率", "负荷", "频率", "效率"] },
        { left: ["运行时长", "用电量"] },
      ],
    },
    暖水泵: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }],
      single: [
        { left: ["压力"] },
        { left: ["温度", "流量"] },
        { left: ["电流", "电压", "有功功率", "负荷", "频率", "效率"] },
        { left: ["运行时长", "用电量"] },
      ],
    },
  };
  return matchingParams?.[type]?.[subType] || [];
}

export function matchingDHWEchartsParams(type, subType) {
  const matchingParams = {
    空气源热泵: {
      total: [
        { left: ["供热量"] },
        { left: ["用电量"] },
        { left: ["锅炉负荷率"] },
        { left: ["锅炉效率"] },
      ],
      single: [
        { left: ["温度", "流量", "压力"] },
        { left: ["供热量"] },
        { left: ["用电量"] },
        { left: ["热泵效率"] },
      ],
    },
    储热水箱: {
      total: [{ left: ["温度", "流量", "压力"] }, { left: ["用水量"] }],
      single: [{ left: ["温度", "流量", "压力"] }, { left: ["用水量"] }],
    },
    保温水箱: {
      total: [{ left: ["温度", "流量", "压力"] }, { left: ["用水量"] }],
      single: [{ left: ["温度", "流量", "压力"] }, { left: ["用水量"] }],
    },
    锅炉: {
      total: [
        { left: ["供热量"] },
        { left: ["用气量"] },
        { left: ["锅炉负荷率"] },
        { left: ["锅炉效率"] },
      ],
      single: [
        { left: ["温度", "压力", "流量", "水位"] },
        { left: ["供热量"] },
        { left: ["用气量"] },
        { left: ["锅炉效率"] },
      ],
    },
    燃烧风机: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }],
      single: [
        { left: ["电流", "电压", "有功功率", "负荷", "频率", "效率"] },
        { left: ["运行时长", "用电量"] },
      ],
    },
    锅炉热水循环泵: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }],
      single: [
        { left: ["压力"] },
        { left: ["温度", "流量"] },
        { left: ["电流", "电压", "有功功率", "负荷", "频率", "效率"] },
        { left: ["运行时长", "用电量"] },
      ],
    },
    生活热水循环泵: {
      total: [{ left: ["功率"] }, { left: ["用电量"] }],
      single: [
        { left: ["压力"] },
        { left: ["温度", "流量"] },
        { left: ["电流", "电压", "有功功率", "负荷", "频率", "效率"] },
        { left: ["运行时长", "用电量"] },
      ],
    },
  };
  return matchingParams?.[type]?.[subType] || [];
}

export function matchingParamsName(val) {
  if (val == "LoadSEER") {
    return "额定SEER";
  }
  if (val == "SEER") {
    return "实时SEER";
  }
  return val;
}

export function matchingAirEchartsName(val) {
  if (val == "in") {
    return "进水";
  }
  if (val == "out") {
    return "出水";
  }
  return val;
}

export function getProjectVal(val) {
  return JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0][
    `project${val}`
  ];
}

export function getUserInfoVal(val) {
  return JSON.parse(window.sessionStorage.getItem("userInfo"))[val];
}

export const getSvgOptions = (data = [], typeName) => {
  const obj = {
    selectOptions: [],
    firstValue: "",
  };
  Array.isArray(data) &&
    data.forEach((item) => {
      if (!item?.[typeName]) {
        return;
      }
      const value = `${item?.[typeName]}?tenant_id=${getUserInfoVal(
        "tenantId"
      )}`;
      // const value = item?.[typeName] ? `${item?.[typeName]}?tenant_id=${getUserInfoVal('tenantId')}` : '@/assets/images/svg/empty.svg'
      if (obj.selectOptions.length === 0) {
        obj.firstValue = value;
      }
      obj.selectOptions.push({
        id: item?.id,
        name: item?.name,
        value,
      });
    });
  return obj;
};

//获取svg的参数,用于api轮询
export const getParamsFromDtos = (svgDtos, $_) => {
  const params = [];
  const nodeData = $_.cloneDeep(svgDtos) || [];
  nodeData.forEach((item) => {
    const { entityId = "", entityType = "DEVICE", dataKey = "" } = item;
    const entityIdIndex = $_.findIndex(params, function (o) {
      return o.entityId.id === entityId;
    });
    if (entityIdIndex == -1) {
      params.push({
        entityId: {
          id: entityId,
          entityType,
        },
        keys: dataKey,
      });
    } else {
      params[entityIdIndex] = {
        entityId: {
          id: entityId,
          entityType,
        },
        keys: `${params[entityIdIndex]?.keys},${dataKey}`,
      };
    }
  });
  return params;
};

//获取svg的参数,用于websocket
export const getParamsFromDtosToWs = (svgDtos, $_) => {
  const params = [];
  const nodeData = $_.cloneDeep(svgDtos) || [];
  nodeData.forEach((item) => {
    const { entityId = "", entityType = "DEVICE", dataKey = "" } = item;
    const entityIdIndex = $_.findIndex(params, function (o) {
      return o.entityId === entityId;
    });
    if (entityIdIndex == -1) {
      params.push({
        entityType,
        entityId,
        keys: dataKey,
        scope: "LATEST_TELEMETRY",
        // timeWindow:3000,
        // startTs:3000,
      });
    } else {
      params[entityIdIndex] = {
        entityType,
        entityId,
        keys: `${params[entityIdIndex]?.keys},${dataKey}`,
        scope: "LATEST_TELEMETRY",
        // timeWindow:3000,
        // startTs:3000,
      };
    }
  });
  const returnObj = { params: { tsSubCmds: [] }, cmdIdMap: {} };
  params.forEach((item, index) => {
    const cmdId = index + 1;
    returnObj.params.tsSubCmds.push({
      ...item,
      cmdId,
    });
    returnObj.cmdIdMap[cmdId] = item.entityId;
  });
  return returnObj;
};

//处理保留小数位数,digit为位数
export const dealNumWith = (num, digit, emptyStr = "——") => {
  var result = parseFloat(num);
  if (isNaN(result)) {
    return emptyStr;
  }
  const digitTemp = Math.pow(10, digit);
  result = Math.round(num * digitTemp) / digitTemp;
  return result;
};

/**
 * judgeAuthority 判断页面权限
 * @param str 页面权限 export
 */
export const judgeAuthority = (str) => {
  return JSON.parse(
    window.sessionStorage.getItem("userInfo")
  ).permissions.includes(str);
};

/**
 * judgeAuthority 处理导出excel数据格式
 * @param tabHead 表单头部
 * @param tableData 表单数据
 */
export const exportExcelFun = (tabHead, tableData) => {
  let th = [];
  tabHead.map((v) => {
    th.push(v.label);
  });
  let content = [];
  tableData.map((v) => {
    let row = [];
    tabHead.map((item) => {
      row.push(v[item.prop]);
    });
    content.push(row);
  });
  return [th, ...content];
};

/**** 巡检计划匹配** */
export function matchingWeekToChinses(val) {
  let obj = {
    0: "天",
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

/**** 空调模式匹配** */
export function matchingAirConditioningMode(val) {
  let obj = {
    0: "制冷",
    1: "制热",
    2: "通风",
    3: "除湿",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

/**** 碳、电、水、气** */
export function matchingECMode(val) {
  let obj = {
    gc: "用气",
    ec: "用电",
    fc: "用水",
    cc: "用碳",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

/**** 动力系统运转状态** */
export function matchingDynamicalState(val) {
  let obj = {
    0: "关闭",
    1: "等待",
    run: "运行",
    2: "等待",
    3: "运行",
    4: "上行",
    5: "下行",
    98: "维修",
    99: "保养",
    RUN: "运行功率",
    WAIT: "等待功率",
  };
  if (obj.hasOwnProperty(val)) {
    return obj[val];
  }
}

/**** 判断数字** */
export function handleJudgmentNumbers(val) {
  return typeof val === "number" && !isNaN(val);
}
/**** 保留两位小数** */
export function handleNumDecimal(val) {
  if (val == 0) {
    return val;
  } else if (val === undefined || val === null || val === "") {
    return "";
  } else {
    return Number.isInteger(Number(val)) ? val : Number(val).toFixed(2);
  }
}

/*** 匹配能源的名称和单位 */
export function matchingECNameUnit(val, key) {
  const matchingVal = {
    power: {
      name: "用电量",
      title: "能耗",
      unit: "kw·h",
      device: "电表",
    },
    gas: {
      name: "用气量",
      title: "用气",
      unit: "m³",
      device: "气表",
    },
    water: {
      name: "用水量",
      title: "用水",
      unit: "m³",
      device: "水表",
    },
  };
  return matchingVal?.[val]?.[key] || "";
}

//获取默认图表x时间
export const getXData = (xdata = [], activeIndex = 0, sumNum = 0) => {
  return Array.from({ length: xdata[activeIndex] }, (_, index) =>
    index + sumNum < 10 ? `0${index + sumNum}` : index + sumNum
  );
};
